import React from 'react'
import { Spin } from 'antd'

import { Loader } from './styled'
import { withTranslation } from 'react-i18next'

const ContentLoader = ({ t }) => {
  return (
    <Loader>
      <Spin tip={t('general:loading')}/>
    </Loader>
  )
}

export default withTranslation()(ContentLoader)
